import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Jobs } from "../../Interface/Jobs/jobs";
import { Constant } from "../../Shared/Models/constant";

@Injectable({
  providedIn: "root",
})
export class JobsService {
  Jobs: Observable<Jobs[]>;
  Constants = new Constant();
  private readonly url: string = this.Constants.localhost_url;

  private readonly Addnewjobs = this.url + "api/jobms";
  private readonly Deletejobs = this.url + "api/job/";
  private readonly NotYetAssigned = this.url + "api/jobms";
  private readonly Assigned = this.url + "api/jobms";
  private readonly pendingBills = this.url + "api/jobms";
  private readonly Tobeapproved = this.url + "api/jobms";
  private readonly Rejected = this.url + "api/jobms";
  private readonly Approved = this.url + "api/jobms";
  private readonly Completed = this.url + "api/jobms";
  private readonly Detail = this.url + "api/jobms/";
  private readonly bankDetails = this.url + "api/post-bank-details";
  private readonly deleteBankDetails = this.url + "api/delete-bank/";
  private readonly getLabourRemark = this.url + "api/get-labour-remarks/";
  private readonly deleteLabourRemark = this.url + "api/delete-labour-remarks/";
  private readonly VehicleDetail = this.url + "api/job/get-vehicle-detail";
  private readonly VehicleVariant = this.url + "api/job/vehicle-variants/";
  private readonly approvedstatusedit = this.url + "api/job/update-job/";
  private readonly updateJob = this.url + "api/job/update-job/";
  private readonly assignedemployee = this.url + "api/job-assign-ms";
  private readonly jobeditdetail = this.url + "api/jobms/";
  private readonly inspectionDetail = this.url + "api/update-inspection";
  private readonly approvedinpectionsave = this.url + "api/ms/post/tab-data";
  private readonly approvedinspectionget = this.url + "api/ms/get/tab-data";
  private readonly rejectJob = this.url + "api/job/";
  private readonly clientbranch = this.url + "api/clientbranch";
  private readonly updateRemark = this.url + "api/job/update-remark/";
  private readonly sentReportMail = this.url + "api/job/send-mail-report";
  private readonly updateJobImageUrl = this.url + "api/job/update-job-image/";
  private readonly contactPerson = this.url + "api/contactperson";
  private readonly inspectionDetailbyid = this.url + "api/get-job-by-id/";
  private readonly fileUpload = this.url + "api/file_upload";
  private readonly manualUpload = this.url + "api/manual-upload";
  private readonly surveyLink = this.url + "api/job-link-create/";
  private readonly assessmentLink = this.url + "api/assessment/";
  private readonly bodyAssessmentLink = this.url + "api/save-update-cabin-body-assessment/";
  private readonly bodyCabinTax = this.url + "api/save-update-cabin-body-tax/";
  private readonly getBodyAssessmentLink = this.url + "api/get-cabin-body-assessment-list/";
  private readonly getBodyTaxLink = this.url + "api/get-cabin-body-tax-setting/";
  private readonly getBodyAssessmentSummary = this.url + "api/get-cabin-body-assessment-summary/";
  private readonly taxDepSetting = this.url + "api/taxdepsetting/";
  private readonly isZeroDepSetting = this.url + "api/gettaxdep/";
  private readonly inspectionjobstatus = this.url + "api/inspection-jobstatus/";
  private readonly summaryLink = this.url + "api/getassessmentsummary/";
  private readonly summaryDataSave = this.url + "api/assesment-inputupdate";
  private readonly storeAttachmentMaster = this.url + "api/storeattachmentmaster";
  private readonly deleteMasterAttachment = this.url + "api/deletemasterattachment?";
  private readonly saveDynamicSectionMaster = this.url + "api/savedynamicsectionmaster";
  private readonly deleteDynamicSectionMaster = this.url + "api/deletedynamicsectionmaster?";
  private readonly getDynamicSectionMasterData = this.url + "api/getdynamicsectionmasterdata";
  private readonly vehicleApiData = this.url + "api/getvehicledata";
  private readonly getJobDetailsList = this.url + "api/get_job_details_list";
  private readonly getStructureList = this.url + "api/ms/get-estimate-structure";
  private readonly storeStructureData = this.url + "api/ms/import-estimate-structure";
  private readonly base64URL = this.url + "api/ms/get/base-encode";
  private readonly getStructureInfo = this.url + "api/ms/estimate-structure-details/";
  private readonly feeBillRefreshURL = this.url + "api/fee-bill-calculation/";
  private readonly reclaim = this.url + "api/check-vehicle";

  private readonly uploadFileURL = "https://moval.techkrate.in/backend/api/v2/extract-tables"; // new API 

  // private readonly uploadFileURL = this.url + "api/extract-tables"; //Old Api 
  
  private readonly getUpdateForData = "https://moval.techkrate.in/backend/api/job-status/";

  //All Claims section only
  private readonly AllClaimsAPI = this.url + "api/jobms";
  private readonly AddLocalWorkshop = this.url + "api/add-local-workshop";
  private readonly EditLocalWorkshop = this.url + "api/edit-local-workshop/";
  private readonly AddPrivateTemplate = this.url + "api/ms/add-pod-template";
  private readonly replaceTagURL = this.url + "api/ms/replace-tags-data/";
  private readonly GetPrivateTemplate = this.url + "api/ms/pod-template-list/"
  private readonly saveUpdateLabourRemark = this.url + "api/save-update-labour-remarks"
  private readonly saveEstimateDetails = this.url + "api/save-update-estimates-details/";
  private readonly getEstimateDetails = this.url + "api/get-estimated-detail/";
  private readonly getEstimateDetailsUrl = this.url + "api/delete-estimates-details";
  private readonly fileExcellUpload = this.url + "api/ms/import";
  private readonly reportSettingsApi = this.url + "api/ms/report-settings";
  private readonly depreciations = this.url + 'api/depreciations';

  constructor(private readonly httpClient: HttpClient) { }

  contactpersonlist(id: string): Observable<any> {
    return this.httpClient.get(
      `${this.contactPerson + "?all=&branch_id="}` + id
    );
  }

  getBase64URL(urlData): Observable<any> {
    let file = {
      url: urlData,
    };
    return this.httpClient.post(`${this.base64URL}`, file);
  }

  vehicleData(
    vehicle_make,
    vehicle_variant = "",
    vehicle_model = ""
  ): Observable<any> {
    return this.httpClient.get(
      `${this.vehicleApiData}?vehicle_make=${vehicle_make}&vehicle_variant=${vehicle_variant}&vehicle_model=${vehicle_model}`
    );
  }

  getJobDetails() {
    return this.httpClient.get(`${this.getJobDetailsList}`);
  }

  structureList(): Observable<any> {
    return this.httpClient.get(`${this.getStructureList}`);
  }

  Addjobs(Addjobsdata: Object, id = null): Observable<any> {
    if (id) return this.jobEditDetail(Addjobsdata, id);
    else return this.httpClient.post(`${this.Addnewjobs}`, Addjobsdata);
  }

  storeStructure(formValue: Object): Observable<any> {
    return this.httpClient.post(`${this.storeStructureData}`, formValue);
  }

  saveEstimateDetail(formValue: Object, id): Observable<any> {
    return this.httpClient.post(`${this.saveEstimateDetails}${id}`, formValue);
  }

  getEstimateDetail(id): Observable<any> {
    return this.httpClient.get(`${this.getEstimateDetails}` + id);
  }

  getStructureData(id): Observable<any> {
    return this.httpClient.get(`${this.getStructureInfo}` + id);
  }

  storeAttachment(Addattachment: Object): Observable<any> {
    return this.httpClient.post(
      `${this.storeAttachmentMaster}`,
      Addattachment
    );
  }

  deleteAttachment(id): Observable<any> {
    return this.httpClient.delete(
      `${this.deleteMasterAttachment}key=` + id
    );
  }

  JobsNotYetAssigned(
    PageNo: string,
    SearchTxt: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {

    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.NotYetAssigned +
      "?status=created&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo
      }`
    );
  }

  JobsAssigned(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {

    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.Assigned +
      "?status=pending&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }

  PendingBillsList(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {

    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.pendingBills +
      "?status=billing&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }

  JobsTobeapproved(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {

    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.Tobeapproved +
      "?status=submitted&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }

  JobsRejected(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {

    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.Rejected +
      "?status=rejected&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }

  JobsApproved(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {
    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.Approved +
      "?status=approved&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }

  JobsCompleted(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean,
    billing = false
  ): Observable<any> {
    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }
    var status = billing ? "billing_finalized,finalized" : "finalized";
    return this.httpClient.get(
      `${this.Completed +
      "?status=" + status + "&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }


  getAllClaims(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean,
    status?: string
  ): Observable<any> {

    // Use provided status, or default to all statuses, or use SearchTxt if searching by status
    let finalStatus = status || 'created,pending,submitted,approved,finalized';
    let query = SearchTxt || '';
    let type = search_type || 'registration_no';

    // If search_type is 'status' and SearchTxt is provided, use SearchTxt as status
    // (unless a status parameter was explicitly provided)
    if (!status && search_type === 'status' && SearchTxt) {
      finalStatus = SearchTxt.trim().toLowerCase();
      // Clear query and type so backend strictly uses status param
      query = '';
      type = '';
    }

    const params = {
      status: finalStatus,
      is_offline: isOffline ? 'yes' : 'no',
      q: query,
      from_date: FromDate || '',
      to_date: ToDate || '',
      page: PageNo,
      search_type: type
    };

    return this.httpClient.get(this.AllClaimsAPI, { params });
  }

  checkVehicle(regNo: string) {
    return this.httpClient.post<any>(
      `${this.reclaim}?vehicle_reg_no=${encodeURIComponent(regNo)}`,
      {}
    );
  }

  // api.service.ts

  // checkVehicle(regNo: string) {
  //   return this.httpClient.post<any>(
  //     'http://127.0.0.1:8000/api/check-vehicle',
  //     { vehicle_reg_no: regNo }
  //   );
  // }


  JobDelete(id: string): Observable<any> {
    return this.httpClient.delete(`${this.Deletejobs}` + id);
  }

  MasterDelete(id: string): Observable<any> {
    return this.httpClient.delete(
      `${this.deleteDynamicSectionMaster}id=` + id
    );
  }

  JobDetail(id: string): Observable<any> {
    return this.httpClient.get(`${this.Detail}` + id);
  }

  MasterDetail(): Observable<any> {
    return this.httpClient.get(`${this.getDynamicSectionMasterData}`);
  }

  SaveMasterDetail(formData): Observable<any> {
    return this.httpClient.post(
      `${this.saveDynamicSectionMaster}`,
      formData
    );
  }

  InspectionDetailbyid(id): Observable<any> {
    return this.httpClient.get(`${this.inspectionDetailbyid}` + id);
  }

  AssesmentInspectionDetailbyid(formName, id): Observable<any> {
    return this.httpClient.get(
      `${this.approvedinspectionget}?type=${formName}&inspection_id=` +
      id
    );
  }

  UpdateJobRemark(id: string, obj: object): Observable<any> {
    return this.httpClient.put(`${this.updateRemark}` + id, obj);
  }

  CreateSurveyLink(id: string): Observable<any> {
    return this.httpClient.get(`${this.surveyLink}` + id);
  }

  ApprovedStatusEdit(id: string): Observable<any> {
    return this.httpClient.put(`${this.rejectJob}` + id + "/approved", {}
    );
  }

  CompletedStatusEdit(id: string): Observable<any> {
    return this.httpClient.get(`${this.rejectJob + "finalize-report/"}` + id);
  }

  SummaryDataSave(formData): Observable<any> {
    return this.httpClient.post(`${this.summaryDataSave}`, formData);
  }

  SentMailReport(employeeedit: object, jobid: string): Observable<any> {
    return this.httpClient.post(`${this.sentReportMail}`, employeeedit);
  }

  AssignedEmployeelist(
    employeeedit: object,
    jobid: string,
    AssignName
  ): Observable<any> {
    return this.httpClient.post(`${this.assignedemployee}`, employeeedit);
  }

  jobEditDetail(jobdata: Object, id: string): Observable<any> {
    jobdata['admin_branch_id'] = "" + jobdata['admin_branch_id'];
    return this.httpClient.put(`${this.jobeditdetail}` + id, jobdata);
  }

  InspectionDetail(jobdata: Object): Observable<any> {
    return this.httpClient.post(`${this.inspectionDetail}`, jobdata);
  }

  ApprovedFormSubmit(jobdata: Object): Observable<any> {
    return this.httpClient.post(`${this.approvedinpectionsave}`, jobdata);
  }

  jobUpdateDetail(jobdata: Object, id: string): Observable<any> {
    return this.httpClient.put(`${this.updateJob}` + id, jobdata);
  }

  rejectJobService(id: string, remark: string): Observable<any> {
    return this.httpClient.put(
      `${this.rejectJob}` + id + "/rejected",
      { remark: remark }
    );
  }

  getVehicleDetails(obj: object): Observable<any> {
    return this.httpClient.post(`${this.VehicleDetail}`, obj);
  }

  getVehicleVariant(obj: object, id: string): Observable<any> {
    return this.httpClient.post(`${this.VehicleVariant}` + id, obj);
  }

  branchlist(id: string): Observable<any> {
    return this.httpClient.get(`${this.clientbranch + "?all=&client_id="}` + id);
  }

  updateJobImage(
    file: File,
    jobid: string,
    imageid: string,
    type: string
  ): Observable<any> {
    let formParams = new FormData();
    formParams.append("file", file);
    formParams.append("type", type);
    formParams.append("image_id", imageid);
    return this.httpClient.post(
      `${this.updateJobImageUrl}` + jobid,
      formParams
    );
  }

  uploadJobDoc(Base64Image): Observable<any> {
    return this.httpClient.post(`${this.fileUpload}`, Base64Image);
  }

  UploadJob(fileList): Observable<any> {
    return this.httpClient.post(`${this.manualUpload}`, fileList);
  }

  AssessmentDetail(id): Observable<any> {
    return this.httpClient.get(`${this.assessmentLink}` + id);
  }

  SummaryLink(id): Observable<any> {
    return this.httpClient.get(`${this.summaryLink}` + id);
  }

  TaxDepSetting(id): Observable<any> {
    return this.httpClient.get(`${this.taxDepSetting}` + id);
  }

  isZeroDepSettings(id): Observable<any> {
    return this.httpClient.get(`${this.isZeroDepSetting}` + id + "?IsZeroDep=1");
  }

  SaveTaxDepSetting(FileData, id): Observable<any> {
    return this.httpClient.post(`${this.taxDepSetting}` + id, FileData);
  }

  InspectionApproved(id): Observable<any> {
    return this.httpClient.get(`${this.inspectionjobstatus}` + id);
  }

  AssessmentSubmit(FileData, id): Observable<any> {
    return this.httpClient.post(`${this.assessmentLink}` + id, FileData);
  }

  bodyCabinAssessmentSubmit(FileData, id): Observable<any> {
    return this.httpClient.post(`${this.bodyAssessmentLink}` + id, FileData);
  }

  bodyCabinTaxSubmit(FileData, id): Observable<any> {
    return this.httpClient.post(`${this.bodyCabinTax}` + id, FileData);
  }

  getBodyCabinAsseementApi(id): Observable<any> {

    return this.httpClient.get(`${this.getBodyAssessmentLink}` + id);
  }

  getBodyCabinAssementSummary(id): Observable<any> {
    return this.httpClient.get(`${this.getBodyAssessmentSummary}` + id);
  }

  getBodyCabinAssementTaxLink(id): Observable<any> {
    return this.httpClient.get(`${this.getBodyTaxLink}` + id);
  }

  saveBodyCabinAssementTaxLink(FileData, id): Observable<any> {
    return this.httpClient.post(`${this.bodyCabinTax}` + id, FileData);
  }

  uploadPDf(FileData): Observable<any> {

    return this.httpClient.post(`${this.uploadFileURL}`, FileData);
  }

  getUpdateUsingId(taskId): Observable<any> {
    return this.httpClient.get(`${this.getUpdateForData}${taskId}`);
  }

  feeBillRefresh(id): Observable<any> {
    return this.httpClient.get(`${this.feeBillRefreshURL}${id}`);
  }

  getLocalWorkshop(id): Observable<any> {
    return this.httpClient.get(`${this.EditLocalWorkshop}${id}`);
  }

  getTemplateDetails(id): Observable<any> {
    return this.httpClient.get(`${this.GetPrivateTemplate}${id}`);
  }

  storeLocalWorkshop(FileData): Observable<any> {
    return this.httpClient.post(`${this.AddLocalWorkshop}`, FileData);
  }

  storeTemplate(FileData): Observable<any> {
    return this.httpClient.post(`${this.AddPrivateTemplate}`, FileData);
  }

  replaceTagData(id): Observable<any> {
    return this.httpClient.get(`${this.replaceTagURL}${id}`);
  }

  saveBankDetails(FileData): Observable<any> {
    return this.httpClient.post(`${this.bankDetails}`, FileData);
  }

  removeBankDetails(index): Observable<any> {
    return this.httpClient.delete(`${this.deleteBankDetails}${index}`);
  }

  getLabourRemarkData(admin_id, type): Observable<any> {
    return this.httpClient.get(`${this.getLabourRemark}${admin_id}/${type}`);
  }

  saveUpdateLabourRemarkData(FileData, id) {
    let url = id ? this.saveUpdateLabourRemark + '/' + id : this.saveUpdateLabourRemark;
    return this.httpClient.post(`${url}`, FileData);
  }

  deleteLabourRemarkApi(admin_id, id) {
    return this.httpClient.delete(`${this.deleteLabourRemark}${admin_id}/${id}`);
  }

  deleteEstimateDetails(id: string): Observable<any> {
    return this.httpClient.delete(`${this.getEstimateDetailsUrl}/${id}`);
  }

  uploadFile(formData: FormData): Observable<any> {
    return this.httpClient.post(`${this.fileExcellUpload}`, formData);
  }

  submitReportSettings(reportSettings: any): Observable<any> {
    return this.httpClient.post<any>(`${this.reportSettingsApi}`, reportSettings);
  }

  getReportSettings(id) {
    return this.httpClient.get<any>(`${this.reportSettingsApi}/${id}`);
  }

  getDepreciations(inspectionId, type) {
    return this.httpClient.get<any>(`${this.depreciations}/${inspectionId}/${type}`);
  }

}
